var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navlink",class:{ menu: _vm.menu, dark: _vm.dark, border: _vm.border },on:{"mouseenter":_vm.mouseenter}},[_c('span',{ref:"span"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }